(function () {

    // Show the matching COA content based on lot number
    function showCoaContent(lotNumber) {
        if (!lotNumber) {
            return false;
        }
        // check if lotNumber is at least 4 characters
        if (lotNumber.length < 4) {
            return false;
        }

        // Convert lot number to lowercase and remove spaces
        lotNumber = lotNumber.toLowerCase();
        lotNumber = lotNumber.replace(/ /g, '');
        
        // Find all matching content by data-coa-id
        const coaContent = document.querySelectorAll(`.coaform__content[data-coa-id*="${lotNumber}"]`);     
        
        // Hide all content elements
        const allCoaContents = document.querySelectorAll('.coaform__content');
        allCoaContents.forEach(content => {
            content.style.display = 'none';
        });
        const noContentMessage = document.querySelector('.coaform__no-content-message');
        noContentMessage.style.display = 'none';
        
        if (coaContent) {
            // Show the matching content
            coaContent.forEach(content => {
                content.style.display = 'block';
            });
            return true;
        } else {
            // Show the no content found message
            if (noContentMessage) {
                noContentMessage.querySelector('#no-content-lot-number').textContent = lotNumber;
                noContentMessage.style.display = 'block';
            }
        }
        return false;
    }
    
    // Check for lot_number URL parameter on page load
    const urlParams = new URLSearchParams(window.location.search);
    const lotNumberParam = urlParams.get('lot_number');
    
    if (lotNumberParam) {
        showCoaContent(lotNumberParam);
    }
    
    // Handle form submission
    const coaForm = document.querySelector('.coaform-form');
    
    if (coaForm) {
        coaForm.addEventListener('submit', function(event) {
            // Prevent default form submission
            event.preventDefault();
            
            // Get the lot_number value from the form
            const lotNumberInput = coaForm.querySelector('input[name="lot_number"]');
            let lotNumber = lotNumberInput ? lotNumberInput.value.trim() : '';
            lotNumber = lotNumber.toLowerCase();
            lotNumber = lotNumber.replace(/ /g, '');
            
            if (lotNumber) {
                // Show the matching content
                showCoaContent(lotNumber);
                
                // Add the lot_number to the URL
                const url = new URL(window.location.href);
                url.searchParams.set('lot_number', lotNumber);
                window.history.pushState({}, '', url);
            }
        });
    }
})();
